<template>
    <div class="body">
        <p class="font1" style="padding-top: 8vh;">📚 书籍是通向智慧的钥匙</p>
        <p class="font1">让我们在知识的海洋中遨游</p>
        <p class="font1">发现更好的自己！</p>
    
        <div class="wrapper">
            <div v-for="(book, index) in books" :key="index" class="book-card">
                <div class="inline-row">
                    <input type="checkbox" :value="book.title" v-model="selectedCourses" />
                    <strong>{{ book.title }}</strong>
                </div>
                <div class="book-info">
                    <p class="book-author" style="text-align: center;">{{ book.author }}</p>
                    <div class="book-desc" v-html="book.description"></div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      ReportData: {
        type: Object,
        required: false
      },
      selected: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selectedCourses: [],
        books: [
          {
            title: '写给大家看的设计书',
            author: 'Robin Williams',
            description: `
              畅销设计入门书最新版，让每个人都能成为设计师。
              在这个创意无处不在的时代，越来越多的人成为设计师。简历、论文、PPT、个人主页、博客、活动海报、给客人的邮件、名片……，处处都在考验你的设计能力。
            `,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=54990'
          },
          {
            title: 'IDEO，设计改变一切',
            author: '蒂姆•布朗(Tim Brown)',
            description: `
              IDEO总裁兼首席执行官蒂姆•布朗 最新著作。<br>
              创新工场董事长兼首席执行官 李开复 隆重推荐。<br>
              这不是写给设计师看的书，是为追求设计思考的组织及个人打造的蓝图，协助将设计思考这种以创意解决难题的做法，带进生活、组织、产品和服务，为社会整体和企业发掘新的替代方案。
            `,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=53931'
          }
        ]
      };
    },
    watch: {
      selectedCourses: {
        deep: true,
        handler(newVal) {
          this.$emit('update:selected', newVal);
        }
      }
    },
    mounted() {
      this.selectedCourses = [...this.selected];
    },
  };
  </script>
  <style scoped>
  .body {
      background: 
      url("../../assets/25July/logo.png") right  top  no-repeat,
      url("../../assets/25July/bg.jpg")  no-repeat;
      background-size:100% 100%,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 96%;
      margin: 0;
      text-align: center;
      font-size: 20px;
      color: #7126d3;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #c539cd;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .wrapper {
      width: 90%;
      text-align: justify;
      margin: 0 auto;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  .inline-row {
    display: flex;
    align-items: center;     /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    gap: 8px;                /* 他们之间间距 */
    width: 100%;     
    color: #c539cd;  
    padding-top: 10px;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25July/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font1{
    text-align: center;
  }
  .wrapper {
      width: 80%;
      text-align: justify;
      margin: 0 auto;
      font-size: 18px;
      /* border-radius: 10px; */
      /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  }
}
</style>